import { render, staticRenderFns } from "./PaymentAttachments.vue?vue&type=template&id=3037c7b9&scoped=true"
import script from "./PaymentAttachments.vue?vue&type=script&lang=js"
export * from "./PaymentAttachments.vue?vue&type=script&lang=js"
import style0 from "./PaymentAttachments.vue?vue&type=style&index=0&id=3037c7b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3037c7b9",
  null
  
)

export default component.exports